import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { theme } from "../../../helpers/theme";
import {
  PriceList,
  PricelistGetByIdPayload,
} from "../../../services/warehouses/pricelist-get-by-id/types";
import { pricelistGetById } from "../../../services/warehouses/pricelist-get-by-id";
import { StyledTable } from "../../../components/table/styled-table";
import {
  dateFormating,
  getMagazineTypeFromEnum,
  getServiceFromEnum,
  getUnitFromEnum,
  priceFormating,
} from "../operator-orders-offering/helpers";
import { StyledButton } from "../../../components/Button/button";
import { GoBackButton } from "../../../components/GoBackButton";

const OperatorWarehousesPricelist = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 250,
      sortable: false,
      disableColumnMenu: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{
            backgroundColor: theme.colors.blue01_active,
          }}
          onClick={() => {
            return navigate(
              `/operator/subcontractors/price-list/edit/${params.id}`,
              { state: { id_magazyn: id, pricelist: pricelist } }
            );
          }}
        >
          Edytuj
        </Button>
      ),
    },
    {
      field: "usluga_magazynu",
      headerName: "Usługa",
      width: 250,
    },
    {
      field: "rodzaj_oferty",
      headerName: "Rodzaj oferty",
      width: 200,
    },
    {
      field: "nazwa",
      headerName: "Nazwa",
      width: 300,
    },
    {
      field: "stawka_netto",
      headerName: "Stawka netto",
      width: 150,
    },
    {
      field: "jednostka",
      headerName: "Jednostka",
      width: 150,
    },
    {
      field: "nazwa_na_fakture",
      headerName: "Nazwa na fakturę",
      width: 200,
    },
    {
      field: "wazna_od",
      headerName: "Ważna od",
      width: 200,
    },
    {
      field: "wazna_do",
      headerName: "Ważna do",
      width: 200,
    },
  ];

  const [pricelist, setPricelist] = useState<PriceList[]>([]);

  const body = {
    id_magazyn: String(id),
  };

  const PricelistGetById = useQuery(
    ["Pricelist"],
    () => pricelistGetById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setPricelist(data.data.payload.cennik_uslug);
      },
    }
  );

  const rows = pricelist.map((r: PriceList) => ({
    id: r.id_cennik,
    usluga_magazynu: getServiceFromEnum(r.usluga_magazynu),
    rodzaj_oferty: getMagazineTypeFromEnum(r.rodzaj_oferty),
    nazwa: r.nazwa,
    stawka_netto: priceFormating(r.stawka_netto),
    jednostka: getUnitFromEnum(r.jednostka_rozliczenia),
    nazwa_na_fakture: r.nazwa_na_fakture,
    wazna_od: dateFormating(r.wazny_od),
    wazna_do: dateFormating(r.wazny_do),
  }));

  if (PricelistGetById.isLoading || PricelistGetById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <PricelistContainer>
      <GoBackButton description={"Powrót"} goToUrl={-1} />
      <StyledButton
        variant="contained"
        sx={{ width: "202px" }}
        onClick={() => {
          return navigate(`/operator/subcontractors/price-list/add/${id}`, {
            state: { pricelist: pricelist },
          });
        }}
      >
        Dodaj cennik
      </StyledButton>
      <StyledTable
        // getRowId={(row) => row?.id}
        rows={rows}
        columns={columns}
        autoPageSize
      />
    </PricelistContainer>
  );
};

export default OperatorWarehousesPricelist;

const PricelistContainer = styled.div`
  height: 80vh;

  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
